import React, {Fragment, FunctionComponent, useState} from "react";
import {Garage, Organization, Service, Slot} from "@App/types";
import {ServiceIsVehicleReturn} from "@App/utils/conditionals/services";
import {useTranslation} from "react-i18next";
import {GarageIsBookableOnArval} from "@App/utils/conditionals/combinations";
import {BookingType} from "@App/Components/BookingType";
import {useDates} from "@App/hooks/useDates";
import {Modal} from "@App/Components/Modal";
import {AdditionalBookingInformation} from "@App/Components/Partials/AdditionalBookingInformation";

type SelectedHintProps = {
    garage: Garage
    selectedSlot: Slot
    service: Service
    organization: Organization
};

export const SelectedHint: FunctionComponent<SelectedHintProps> = (props: SelectedHintProps) => {
    const {t} = useTranslation() // i18next
    const {formatDate} = useDates()
    const [modalOpened, setModalOpened] = useState(false)

    return (
        <Fragment>
        <div className="mt-5">
            <div>
                {t('booking.chosen-slot')} {props.selectedSlot && (
                <span className="font-bold">
                            {formatDate(props.selectedSlot.starts_at, 'dd.MM.yyyy')} um {formatDate(props.selectedSlot.starts_at, 'HH:mm')} Uhr
                        </span>
            )}
            </div>
            {props.service && !ServiceIsVehicleReturn(props.service) && (
                <div className={'flex text-sm lg:text-base gap-3 lg:gap-4 mt-3 lg:mt-0'}>
                            <span
                                className={"underline text-primary cursor-pointer font-bold"}
                                onClick={() => setModalOpened(true)}>
                                {t('booking.more-information-link')}
                            </span>
                    {
                        GarageIsBookableOnArval(props.organization, props.garage) && (
                            <BookingType liveBookable={props.garage.liveBookable} mobileVisible />
                        )}
                </div>
            )}
            {props.service && ServiceIsVehicleReturn(props.service) && (
                <div className={"font-bold"} dangerouslySetInnerHTML={{__html: t('booking.hint')}}></div>
            )}
        </div>

            <Modal title={t('booking.moreInformation.headline')} width="3xl" open={modalOpened}
                   onClick={() => setModalOpened(false)} onClose={() => setModalOpened(false)}>
                <AdditionalBookingInformation garage={props.garage} organization={organization} service={props.service} />
            </Modal>
        </Fragment>
    );
}


